/**
 * The MCP server URL we show users to paste into Claude, ChatGPT or any MCP client.
 *
 * Operator, 2026-10-05: "We should always be showing/pointing users to
 * mcp.conducktor.com". It is the vanity MCP host the backend serves
 * (backend/app/middleware/vanity_root.py); its OAuth protected-resource metadata
 * names the resource as exactly this URL, with `/mcp` (measured 2026-10-05:
 * GET https://mcp.conducktor.com/.well-known/oauth-protected-resource ->
 * "resource":"https://mcp.conducktor.com/mcp"), and clients compare the two, so the
 * path is part of the URL, not decoration.
 *
 * Every surface that shows users an MCP URL reads this constant. Do not hard-code
 * api.conducktor.com/mcp for users; it still works, but it is not the address we give out.
 */
export const MCP_CONNECT_URL = 'https://mcp.conducktor.com/mcp';
